import Head from "next/head";
import { generateNextSeo } from "next-seo/pages";
import { buildCanonicalUrl } from "lib/seo";

import type { GenericPageData } from "lib/fetchers/genericPage";

import { fetchNavbarAndFooter } from "lib/fetchers/common";
import { fetchGenericPageData } from "lib/fetchers/genericPage";

import GenericPageView from "content-ui/genericPages/index";
import ErrorBoundary from "components/errorBoundary/errorBoundary";
import Navigation from "components/navigation/navigation";
import Footer from "components/footer/footer";

const PAGE_SLUG = "terms-of-use";

export async function getStaticProps({ preview }) {
  const [menuItems, dato] = await Promise.all([
    fetchNavbarAndFooter(),
    fetchGenericPageData({ pageSlug: PAGE_SLUG, preview }),
  ]);

  return {
    props: {
      dato,
      __initialState: {
        sitewideOption: { ...menuItems },
      },
    },
    // we will attempt to re-generate the page:
    // - when a request comes in
    // - at most once every minute
    revalidate: 60,
  };
}

type PageProps = {
  dato: GenericPageData;
};

const TermsOfUsePage = (props: PageProps) => {
  const { title, description, image } = props.dato.seo;

  return (
    <>
      <Head>
        {generateNextSeo({
          title: title,
          description: description,
          canonical: buildCanonicalUrl("/terms-of-use"),
          openGraph: {
            title: title,
            description: description,
            images: [{ url: image?.url }],
          },
          twitter: {
            handle: "@siftedeu",
            site: "@siftedeu",
            cardType: "summary_large_image",
          },
        })}
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <Navigation />

      <ErrorBoundary>
        <GenericPageView {...props.dato} />
      </ErrorBoundary>

      <Footer />
    </>
  );
};

export default TermsOfUsePage;
